module.exports = __webpack_public_path__ + "static/media/norton-grey-bike.9e335121.jpeg";